import React from 'react';
import {connect} from 'react-redux';
import Favico from 'favico.js';

class Focus extends React.Component {
  componentDidMount() {
    this.favico = Favico();
    const {loaded, addedUnlooked: count} = this.props;
    if (loaded && count) {
      this.favico.badge(count);
    }
  }

  componentDidUpdate() {
    const {loaded, addedUnlooked: count} = this.props;
    this.favico.badge(loaded ? count : '');
  }

  componentWillUnmount() {
    this.favico.badge('');
  }

  render() { // eslint-disable-line lodash/prefer-constant
    return null;
  }
}


export default connect(({loadsSearch: {status, addedUnlooked}}) => ({
  addedUnlooked,
  loaded: status === 'ok' || status === 'refreshing',
}))(Focus);



// WEBPACK FOOTER //
// ./src/components/root/Favicon.js